// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-avatar {
  width: 24px;
  height: 24px;
  padding: 0;
  border: 0;
  font-size: 12px;
}

.destructive-action-wrapper {
  margin: 24px 0px 70px 0px;
}

.custom-title {
  color: var(--ion-color-light) !important;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/events/event-detail/event-detail.page.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;EACA,YAAA;EACA,UAAA;EACA,SAAA;EACA,eAAA;AACJ;;AAEA;EACI,yBAAA;AACJ;;AAEE;EACE,wCAAA;AACJ","sourcesContent":["ion-avatar {\n    width: 24px;\n    height: 24px;\n    padding: 0;\n    border: 0;\n    font-size: 12px;\n}\n\n.destructive-action-wrapper{\n    margin: 24px 0px 70px 0px;\n  }\n\n  .custom-title{\n    color: var(--ion-color-light) !important;\n  }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
